import { createSvgIcon } from "@mui/material/utils";

export const WriteIconActive = createSvgIcon(
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.34571 16.9234H6.6535C6.8574 16.9226 7.05272 16.8422 7.19726 16.6976L20.2738 3.62109H20.2746C20.4183 3.47655 20.4996 3.28125 20.4996 3.07655C20.4996 2.26093 20.1754 1.47811 19.598 0.901556C19.0215 0.324219 18.2387 0 17.423 0C17.2184 0 17.023 0.0812497 16.8785 0.224999L3.80195 13.3015V13.3023C3.65742 13.4469 3.57695 13.6422 3.57617 13.8461V16.1539C3.57617 16.3578 3.65742 16.5539 3.80195 16.6976C3.9457 16.8422 4.14179 16.9234 4.34571 16.9234ZM17.7137 1.56647C18.3316 1.68522 18.8144 2.16803 18.9332 2.78601L17.423 4.29694L16.2027 3.07663L17.7137 1.56647ZM5.1153 14.1648L15.1153 4.16486L16.3348 5.3844L6.33484 15.3844H5.1153V14.1648Z"
      fill="#5048E5"
    />
    <path
      d="M19.7305 18.4619H1.26954C0.844539 18.4619 0.5 18.8065 0.5 19.2307C0.5 19.6557 0.844539 20.0002 1.26954 20.0002H19.7305C20.1555 20.0002 20.5 19.6557 20.5 19.2307C20.5 18.8065 20.1555 18.4619 19.7305 18.4619Z"
      fill="#5048E5"
    />
  </svg>,

  "WriteIconActive"
);
